module.exports = __webpack_public_path__ + "img/back.45be39ee.png";